import { A4uAlertCheck as IconComponent } from '@adobe/react-spectrum-workflow/dist/AlertCheck.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function AlertCheck(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}